/*
 * Copyright (c) Dito Technologies LLC
 */

import React from "react";
import styles from "ui/feature/piece-play/common/piece-renderer/PieceRendererStaff.module.scss";

const Line: React.FC = () => {
    return (
        <div className={styles.line}/>
    )
}

const InBetweenLine: React.FC = () => {
    return (
        <div className={styles.inBetweenLineSpacing}/>
    )
}

const PieceRendererStaff: React.FC = () => {

    return (
        <div className={styles.container}>
            <Line/>
            <InBetweenLine/>
            <Line/>
            <InBetweenLine/>
            <Line/>
            <InBetweenLine/>
            <Line/>
            <InBetweenLine/>
            <Line/>
        </div>
    );
}

export default PieceRendererStaff;